<div *ngIf="data" [ngClass]="customClass">
  {{ data }}
</div>
<div *ngIf="!data" [ngClass]="customClass">
  <span>Default</span>
</div>
